import {
  accessoriesSection,
  loadProductAccessories,
  addEventToLoadAccessoriesMobile,
} from './helpers/product-accessories';

if (accessoriesSection) {
  const options = {
    rootMargin: '500px',
    threshold: 0.1,
  };

  const callback = (entries, observerInstance) => {
    if (entries[0].isIntersecting) {
      loadProductAccessories();
      addEventToLoadAccessoriesMobile();
      observerInstance.disconnect();
    }
  };

  const observer = new IntersectionObserver(callback, options);

  window.addEventListener('load', () => {
    observer.observe(accessoriesSection);
  });
}
